import { tagColorClass } from "../lib/tags";

interface Props {
  tag: string;
  onRemove?: () => void;
  onClick?: () => void;
  selected?: boolean;
  size?: "sm" | "md";
}

export default function TagBadge({ tag, onRemove, onClick, selected, size = "sm" }: Props) {
  const base = tagColorClass(tag);
  const sizeCls = size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm";
  const ring = selected ? "ring-2 ring-navy" : "";
  const cursor = onClick ? "cursor-pointer hover:opacity-80" : "";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${base} ${sizeCls} ${ring} ${cursor}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {tag}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-1 rounded-full text-current/60 hover:text-current"
          aria-label={`タグ ${tag} を削除`}
        >
          ×
        </button>
      )}
    </span>
  );
}
